import { render, staticRenderFns } from "./Finalizado.vue?vue&type=template&id=468c67d8&"
import script from "./Finalizado.vue?vue&type=script&lang=js&"
export * from "./Finalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Finalizado.vue"
export default component.exports